import Button from "@mui/material/Button";
import {_transl} from "../../store/localization/TranslMessasge";
import {CommonTranslation} from "../../pages/main/content/CommonTranslation";
import React from "react";
import {ButtonPropTypes} from "./ButtonPropTypes";

interface DeleteButtonProps {
    onClick: (event?: any) => void;
    variant?: ButtonPropTypes.Variant;
    size?: ButtonPropTypes.Size;
    disabled?: boolean;
}

export function DeleteButton(props: Readonly<DeleteButtonProps>) {

    const {onClick, variant, size, disabled} = props;

    return (
        <Button onClick={onClick}
                variant={variant ?? "contained"}
                color={"error"}
                size={size}
                disabled={disabled}>
            {_transl(CommonTranslation.DELETE)}
        </Button>
    )
}

